/**
 * shadcn/ui `cn()` — class merge helper (UI-v2 Phase 1a).
 *
 * Standard shadcn utility: `clsx` for conditional class composition +
 * `tailwind-merge` to dedupe conflicting Tailwind utilities (last-wins).
 * Every vendored `src/components/ui/*` primitive and every v2 component
 * composes classes through this. This is the only shadcn scaffolding file
 * that is NOT v2-scoped — it is a pure, side-effect-free string helper.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
